class QuantityInput extends HTMLElement {
  connectedCallback() {
    const input = this.querySelector('input');
    const minus = this.querySelector('[data-quantity-minus]');
    const plus = this.querySelector('[data-quantity-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', () => { input.value = Math.max(parseInt(input.value || '1', 10) - 1, parseInt(input.min || '1', 10)); input.dispatchEvent(new Event('change', { bubbles: true })); });
    if (plus) plus.addEventListener('click', () => { input.value = parseInt(input.value || '1', 10) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
  }
}
customElements.define('quantity-input', QuantityInput);

document.addEventListener('click', function(event) {
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]') || document;
    const main = gallery.querySelector('[data-gallery-main]') || document.querySelector('[data-gallery-main]');
    const url = thumb.getAttribute('data-gallery-thumb');
    if (url && main && main.tagName === 'IMG') {
      main.src = url;
      gallery.querySelectorAll('.gallery-thumb').forEach(el => el.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
  }

  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    if (menu) menu.hidden = !menu.hidden;
  }
});
